/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from './_guards/authentication.guard';

const routes: Routes = [
  {
    path: 'feature',
    canActivate: [AuthenticationGuard],
    loadChildren:
      () => import('./_routing/feature-routing/feature-routing.module').then(module => module.FeatureRoutingModule)
  },
  {
    path: 'login',
    loadChildren: 
      () => import('./_pages/login/login.module').then(module => module.LoginPageModule)
  },
  {
    path: 'server-settings',
    loadChildren:
      () => import('./_pages/server-settings/server-settings.module').then(module => module.ServerSettingsPageModule)
  },
  {
    path: 'tabbar',
    canActivate: [AuthenticationGuard],
    loadChildren: 
      () => import('./_routing/tabbar/tabbar.module').then(module => module.TabBarPageModule)
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: '**',
    loadChildren: 
      () => import('./_pages/not-found/not-found.module').then(module => module.NotFoundPageModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes), HttpClientModule],
  exports: [RouterModule]
})
export class AppRoutingModule {}
